var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentStatusRefunded(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3425 3.4475H1.68144L3.30321 5.06927C3.49555 5.26157 3.49555 5.57342 3.30321 5.76576C3.20704 5.8619 3.08099 5.91 2.95495 5.91C2.8289 5.91 2.70285 5.8619 2.60672 5.76573L0.144213 3.30323C-0.0481253 3.11092 -0.0481253 2.79907 0.144213 2.60673L2.60672 0.144229C2.79902 -0.0480763 3.11087 -0.0480763 3.30321 0.144229C3.49555 0.336534 3.49555 0.648386 3.30321 0.840723L1.68144 2.4625H10.3425C10.6145 2.4625 10.835 2.683 10.835 2.955C10.835 3.22699 10.6145 3.4475 10.3425 3.4475Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentStatusRefunded);
export default __webpack_public_path__ + "static/media/payment-status-refunded.2e9f3c5f45690cc5f281a4b67aae2569.svg";
export { ForwardRef as ReactComponent };